import React, { Component } from 'react';
import { Row, Col, Panel, Modal, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Field, reduxForm, reset } from "redux-form"
import _ from 'lodash'
import NavHeader from './navheader'
import PromoCode from './component_promocode'
import { setPaymentStage, getDeliveryCharge, clearDeliveryCharge } from '../actions'
import { getMoneyFormat } from '../utils'
import SubMenu from './submenu'
import Footer from './footer'
import Stepper from 'react-stepper-horizontal';
class PageConfirmAddress extends Component {
    state = {
        tabSelect: '1',
        user: JSON.parse(localStorage.getItem('user'))
    }
    onCheckOut() {
        this.props.setPaymentStage('payment')
        this.props.history.push('/payment')
    }
    renderLoader() {
        return (
            <div style={{ display: 'inline-block' }}>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
                <div className="loading-bar"></div>
            </div>
        )
    }

    calculateDeliveryFee(e) {
        this.props.clearDeliveryCharge()
        let today = new Date()
        const preorder = this.props.deliveryTime.split(';').length > 1 ? { data: { success: true, delivery_fee: 50 } } : ''
        const drivethru = e == 2 ? { data: { success: true, delivery_fee: 0, full_delivery_fee: 0, drivethru: true } } : ''
        this.props.getDeliveryCharge({
            latitude: this.state.user.address.address1.latitude,
            longitude: this.state.user.address.address1.longitude,
            delivery_tmr: (this.props.deliveryTime).split(' ')[2] != today.getDate() ? true : '',
        }, preorder, drivethru)
    }


    componentWillMount() {
        if (localStorage.getItem('user') != null) {
            this.setState({ isLogin: true })
            if (_.isEmpty(JSON.parse(localStorage.getItem('cart_products'))) || JSON.parse(localStorage.getItem('cart_products')) == null) {
                window.alert('ไม่มีรายการสินค้า')
                this.props.history.push('/')
            } else {
                if (this.props.payment_stage == 'confirm_address') {
                    if (JSON.parse(localStorage.getItem('user')).address == undefined) {
                        this.props.history.push('/add_address')
                    } else {
                        this.calculateDeliveryFee()
                    }
                } else {
                    this.props.setPaymentStage('idle')
                    this.props.history.push('/order_review')
                }
            }
        } else {
            this.props.history.push('/login')
        }
        // this.handleChange('1')
        window.scrollTo(0, 0)
    }


    handleSelect(eventKey) {
        eventKey.preventDefault()
        this.setState({ tabSelect: eventKey })
    }

    handleChange(e) {
        if (this.props.delivery_charge) {
            this.setState({ tabSelect: e, showModal: false })
            this.calculateDeliveryFee(e)
        }

    }

    renderTab() {
        let color1 = this.state.tabSelect == '1' ? '#6ac259' : ''
        let color2 = this.state.tabSelect == '2' ? '#6ac259' : ''
        return (
            <div>
                <br />
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <Panel style={{ cursor: 'pointer', borderColor: color1 }} onClick={() => { this.handleChange('1') }}>
                            {this.state.tabSelect == '1' ?
                                <img src='../../static/images/checked.png' style={{ display: 'inline-block', width: 25, marginRight: 8 }} />
                                : <img src='../../static/images/checked02.png' style={{ display: 'inline-block', width: 25, marginRight: 8 }} />}
                            <h5 style={{ display: 'inline-block' }}>จัดส่งที่บ้าน</h5>
                        </Panel>
                    </Col>
                    {/* <Col xs={12} sm={12} md={12} lg={12}>
                        <Panel style={{ cursor: 'pointer', borderColor: color2 }} onClick={() => { this.handleChange('2') }}>
                            {this.state.tabSelect == '2' ?
                                <img src='../../static/images/checked.png' style={{ display: 'inline-block', width: 25, marginRight: 8 }} />
                                : <img src='../../static/images/checked02.png' style={{ display: 'inline-block', width: 25, marginRight: 8 }} />}
                            <img src='../../static/images/baac-logo.jpeg' style={{ display: 'inline-block', width: 25, marginRight: 8 }} />
                            <h5 style={{ display: 'inline-block' }}>รับสินค้าที่ตลาดดอนกลาง ไม่เสียค่าจัดส่ง!</h5>
                        </Panel>
                    </Col> */}
                </Row>
            </div>
        )
    }

    renderForm() {
        if (this.state.tabSelect == '1') {
            return (
                <div>
                    {this.renderAddress()}
                    {this.renderOrderSummary()}
                </div>
            )
        }

        if (this.state.tabSelect == '2') {
            return (
                <div>
                    <Panel>
                        <h4 style={{ textAlign: 'center', color: '#696969' }}>ไม่มีค่าจัดส่ง!!! สะดวกและประหยัดรอรับที่ ตลาดดอนกลางได้เลย</h4>
                    </Panel>
                    {this.renderOrderSummary()}
                </div>

            )
        }
    }

    getTotalPrice() {
        let total_price = 0
        _.map(this.props.cart_products, product => {
            total_price += product.product_price_unit * product.product_amount
        })
        return Number(total_price.toFixed(2))
    }
    getTotalAmount() {
        let total_amount = 0
        _.map(this.props.cart_products, product => {
            total_amount += 1
        })
        return Math.round(total_amount)
    }
    renderAddressItem() {
        let id = 0
        let arrayAddress1 = []
        let arrayAddress2 = []
        let arrayAddress3 = []
        let arrayAddress4 = []
        return _.map(this.state.user.address, address => {
            arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ประเภทที่อยู่อาศัย:</strong> {address.residential_type}&nbsp;</div>)
            address.building ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>อาคาร/หมู่บ้าน:</strong> {address['building']}&nbsp;</div>) : ''
            address.room_number ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ห้อง:</strong> {address['room_number']}&nbsp;</div>) : ''
            address.floor ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ชั้น:</strong> {address['floor']}&nbsp;</div>) : ''
            arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>เลขที่:</strong> {address['house_number']}&nbsp;</div>)
            address.road ? arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ถนน:</strong> {address['road']}&nbsp;</div>) : ''
            address.alley ? arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ซอย:</strong> {address['alley']}&nbsp;</div>) : ''
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong>แขวง:</strong> {address['district']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong>เขต:</strong> {address['area']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong>จังหวัด:</strong> {address['province']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong>รหัสไปรษณีย์:</strong> {address['zip_code']}&nbsp;</div>)
            address.landmark ? arrayAddress4.push(<div key={id++} style={{ display: 'inline-block', color: '#163f09' }}><strong>จุดสังเกต:</strong> {address['landmark']}&nbsp;</div>) : ''
            return (
                <Row key={id++}>
                    <div>
                        {/* <div>{arrayAddress1}</div><br /> */}
                        <div>{arrayAddress2}</div><br /><div>{arrayAddress3}</div><br />{arrayAddress4}</div>
                </Row >
            )
        })
    }
    renderAddress() {
        return (
            <Panel>
                <Row>
                    <div><h4 style={{ textAlign: 'left', display: 'inline-block' }}><strong>ที่อยู่</strong></h4><div className='pull-right' style={{ display: 'inline-block', paddingTop: 10, cursor: 'pointer' }} disabled={this.props.delivery_charge ? false : true} onClick={() => { this.props.history.push('/user_info'); this.props.clearDeliveryCharge() }}><a>แก้ไข</a></div></div>
                </Row>
                <Row>
                    <div style={{ marginTop: 20 }}>
                        {this.renderAddressItem()}
                    </div>
                </Row>
            </Panel>
        )
    }
    renderOrderSummary() {
        return (
            <Panel>
                {/* Fixed Delivery Fee */}
                {/* <h4>ค่าจัดส่งเจ้าหน้าที่จะแจ้งอีกครั้งหลังจากติดต่อกลับ</h4> */}
                <h4>ค่าส่งในบริเวณของท่าน: {this.props.delivery_charge ? getMoneyFormat(this.props.delivery_charge.delivery_fee.toFixed(2)) + ' บาท' : this.renderLoader()}</h4>
                <h4><strong style={{ color: '#EA1608' }}>** เจ้าหน้าที่จะคำนวนค่าส่งให้อีกครั้งก่อนยืนยันออเดอร์ **</strong></h4>

                {/* <h4>ค่าส่งในบริเวณของท่าน: <strike>{this.props.delivery_charge ? getMoneyFormat(this.props.delivery_charge.full_delivery_fee.toFixed(2)) + ' บาท' : this.renderLoader()}</strike> <strong style={{ color: '#F37232', display: this.state.tabSelect == 2 ? 'none': '' }}> 50 บาท</strong></h4>
                <strong style={{ color: '#F37232' }}>* ส่วนลดแคมเปญ ส่งสด สู้ COVID-19 </strong><br/>
                <strong style={{ color: '#F37232' }}>* ให้บริการเฉพาะในเขตกรุงเทพฯ เท่านั้น </strong><br/> */}

                <h4>ค่าสินค้า: {getMoneyFormat((this.getTotalPrice() || 0).toFixed(2))} บาท</h4>

                {/* <PromoCode money={(this.getTotalPrice()).toFixed(2)} /> */}

                <h4>ยอดรวม {this.props.delivery_charge ? getMoneyFormat((this.getTotalPrice() + this.props.delivery_charge.delivery_fee - (this.props.discount.value || 0)).toFixed(2)) + ' บาท' : this.renderLoader()}</h4>
                <h4><strong style={{ color: '#F37232' }}>** ยังไม่ต้องโอนเงิน จนกว่าเจ้าหน้าที่จะทำการติดต่อกลับ **</strong></h4>
                {/* <Col style={{ marginRight: 0, paddingRight: 0 }} md={3} sm={3} xs={12}> */}
                <Button disabled={this.props.delivery_charge ? false : true} onClick={() => { this.onCheckOut() }} className='pull-right' style={{ width: 170, height: 40, marginTop: 12 }} bsStyle='success'>ดำเนินการต่อ</Button>
                {/* </Col> */}
            </Panel>
        )
    }
    render() {
        if (this.state.isLogin) {
            return (
                <div>
                    <NavHeader history={this.props.history} />
                    <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                    <div className="container main-bg">
                        <Col md={3} sm={0} xs={0}>
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                            <div>
                                <Stepper
                                    activeColor='#F37232'
                                    completeColor='#F37232'
                                    circleFontSize={14}
                                    circleTop={15}
                                    size={30}
                                    steps={[{ title: 'ตรวจสอบรายการสินค้าในตะกร้า' },
                                    { title: 'เลือกวิธีจัดส่ง' },
                                    { title: 'วิธีชำระเงิน' },
                                    { title: 'สั่งซื้อเรียบร้อย' }]}
                                    activeStep={1} />
                            </div>
                            <h2>กรุณาเลือกวิธีจัดส่ง</h2>
                            {this.renderTab()}
                            {this.renderForm()}

                            {/* <PromoCode /> */}
                        </Col>
                    </div>
                    <Footer history={this.props.history} />
                </div>
            )
        }
        else {
            return (
                <div className='container'>
                    <div className='loader'></div>
                </div>
            )
        }
    }
}
function mapStateToProps(state) {
    return {
        cart_products: state.cart_products_reducer,
        payment_stage: state.payment_stage_reducer,
        delivery_charge: state.delivery_charge_reducer,
        discount: state.promocodeReducer,
        deliveryTime: state.delivery_time_reducer,
    }
}
export default connect(mapStateToProps, { setPaymentStage, getDeliveryCharge, clearDeliveryCharge })(PageConfirmAddress)


// WEBPACK FOOTER //
// ./src/components/page_confirm_address.js